import Swiper, { Navigation, Pagination } from 'swiper/bundle';

var swiper = new Swiper(".mySwiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination-num",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
  });

  var swiperFade = new Swiper(".swiper-fade", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 5500,
      disableOnInteraction: false,
    },
    spaceBetween: 30,
    loop: true,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      bulletClass: "intro-indicator-item",
      bulletActiveClass: "active",
      renderBullet: function (index, className) {
        return '<button class="'+className+'"><span class="d-none">introIndicatorItemButton</span></button>';
      },
      // renderCustom: function(swiper, current, total) {
      //   return '<button class="intro-indicator-item"></button>';
      // },
    },
  });

  var swiperNormal = new Swiper(".swiper-normal", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      360: {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
      },
      540: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
    },
  });